import React from 'react';

import './MoreDescriptionSection.scss';

const MoreDescriptionSection = (props) => (
    <section className="multi-info-section theme-darkblue">
        <div className="container">
            <div className="row">
                <div className="col-12 col-md-3">
                    <img alt="" src={props.img}/>
                </div>
                <div className="col-12 col-md-9 d-flex align-items-center justify-content-center">
                    {props.text}
                </div>
            </div>
        </div>
    </section>
)

export default MoreDescriptionSection;